import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    padding: 6em 0 4em 0;

    .zoom-wrapper {
        position: relative;
        min-width: 20.5em;
        min-height: 31em;
        transform: scale(1.2);
        transition: transform 300ms ease-in-out;

        .hitbox {
            opacity: 0;
            animation: showUp 200ms ease 300ms forwards;

            @keyframes showUp {
                0% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }
        }

        &.zoom-in {
            overflow: hidden;

            .tummy {
                img {
                    transform: scale(1.5) translate(-70px, 10px);
                }
            }

            .whiteLine {
                img {
                    transform: scale(1.5) translate(-70px, 0px);
                }
            }

            .face,
            .chin {
                img {
                    transform: scale(1.5) translate(-70px, 90px);
                }
            }

            .armpits {
                img {
                    transform: scale(1.5) translate(-70px, 50px);
                }
            }

            .bikini {
                img {
                    transform: scale(1.5) translate(-70px, -20px);
                }
            }

            .buttocks {
                img {
                    transform: scale(1.5) translate(80px, 10px);
                }
            }

            .back {
                img {
                    transform: scale(1.5) translate(80px, 60px);
                }
            }

            .thighs {
                img {
                    transform: scale(1.5) translate(-80px, -70px);
                }
            }

            .calves {
                img {
                    transform: scale(1.5) translate(-80px, -90px);
                }
            }

            .feet {
                img {
                    transform: scale(1.5) translate(-80px, -100px);
                }
            }

            .hands {
                img {
                    transform: scale(1.5) translate(-80px, 60px);
                }
            }

            .palm {
                img {
                    transform: scale(1.5) translate(-80px, 90px);
                }
            }

            .button {
                transform: scale(.8);
            }
        }

        .body-base {
            display: flex;
            position: absolute;
            top: 0;
            left: 0;

            .columns-container {
                display: flex;
                position: absolute;

                height: 100%;
                width: 100%;

                .hitboxes-container {
                    display: flex;
                    position: relative;
                    width: 100%;
                    height: 100%;

                    .hitbox {
                        display: flex;
                        position: absolute;
                        cursor: pointer;
                        width: 16px;
                        height: 16px;

                        &__tooltip {
                            position: absolute;
                            background-color: rgba(255, 255, 255, 0.5);
                            box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;
                            padding: 0.2em 0.5em;
                            border-radius: 0.2em;
                            font-size: 14px;
                            pointer-events: none;
                            white-space: nowrap;
                            z-index: 3;
                        }

                        .effect-layer {
                            opacity: 0;
                        }

                        .controls-layer {
                            position: absolute;

                            .control {
                                position: absolute;
                                cursor: pointer;
                                user-select: none;

                                &.circled-cross {
                                    position: relative;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    width: 16px;
                                    height: 16px;
                                    border-radius: 16px;
                                    background: white;
                                    box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;

                                    &:before {
                                        position: absolute;
                                        content: '';
                                        width: 6px;
                                        height: 6px;
                                        border-radius: 6px;
                                        background-color: #BA9449;
                                    }

                                    &:after {
                                        position: absolute;
                                        content: '';
                                        width: 12px;
                                        height: 12px;
                                        border-radius: 12px;
                                        background-color: transparent;
                                        border: 1px solid #BA9449;
                                        opacity: 0.5;
                                    }
                                }
                            }
                        }

                        &:hover {
                            .control {
                                &.circled-cross {
                                    transform: scale(1.2);
                                }
                            }
                        }
                    }

                    &.column-left {
                        width: 50%;

                        .hitbox {
                            &__tooltip {
                                right: 100%;
                                top: calc(-50% + 2px);
                                animation: fadeInAndOpacityLeft 200ms ease forwards;

                                @keyframes fadeInAndOpacityLeft {
                                    0% {
                                        transform: translateX(0);
                                        opacity: 0;
                                    }

                                    100% {
                                        transform: translateX(10px);
                                        opacity: 1;
                                    }
                                }
                            }

                            &#arms {
                                bottom: 0;

                                .hitbox {
                                    &__tooltip {
                                        right: calc(100% + 30px);
                                    }
                                }

                                .controls-layer {
                                    left: 2.6em;
                                    bottom: 20em;
                                }
                            }

                            &#buttocks {
                                left: 3.5em;
                                bottom: 13em;

                                .hitbox {
                                    &__tooltip {
                                        right: calc(100% + 40px);
                                    }
                                }
                            }

                            &#thighs {
                                left: 5em;
                                bottom: 9.4em;

                                .hitbox {
                                    &__tooltip {
                                        right: calc(100% + 50px);
                                    }
                                }
                            }

                            &#calves {
                                left: 50px;
                                bottom: 76px;

                                .hitbox {
                                    &__tooltip {
                                        right: calc(100% + 26px);
                                    }
                                }
                            }

                            &#feet {
                                left: 50px;
                                bottom: 10px;

                                .hitbox {
                                    &__tooltip {
                                        right: calc(100% + 40px);
                                    }
                                }
                            }
                        }
                    }

                    &.column-right {
                        width: 50%;

                        .hitbox {
                            &__tooltip {
                                left: 100%;
                                top: calc(-50% + 2px);
                                animation: fadeInAndOpacityRight 200ms ease forwards;

                                @keyframes fadeInAndOpacityRight {
                                    0% {
                                        transform: translateX(10px);
                                        opacity: 0;
                                    }

                                    100% {
                                        transform: translateX(0);
                                        opacity: 1;
                                    }
                                }
                            }

                            &#hands {
                                left: 2em;
                                bottom: 25em;

                                .hitbox {
                                    &__tooltip {
                                        left: calc(100% + 16px);
                                    }
                                }
                            }

                            &#palm {
                                left: 3.8em;
                                bottom: 28em;

                                .hitbox {
                                    &__tooltip {
                                        left: calc(100% + 16px);
                                    }
                                }
                            }

                            &#chin {
                                left: 5.4em;
                                bottom: 21.2em;

                                .hitbox {
                                    &__tooltip {
                                        left: calc(100% + 30px);
                                    }
                                }
                            }

                            &#mustache {
                                left: 4em;
                                bottom: 23em;

                                .hitbox {
                                    &__tooltip {
                                        left: calc(100% + 30px);
                                    }
                                }
                            }


                            &#face {
                                left: 5.4em;
                                bottom: 24em;

                                .hitbox {
                                    &__tooltip {
                                        left: calc(100% + 30px);
                                    }
                                }
                            }

                            &#armpits {
                                left: 5.4em;
                                bottom: 18.6em;

                                .hitbox {
                                    &__tooltip {
                                        left: calc(100% + 20px);
                                    }
                                }
                            }

                            &#whiteLine {
                                left: 4em;
                                bottom: 14.4em;

                                .hitbox {
                                    &__tooltip {
                                        left: calc(100% + 36px);
                                    }
                                }
                            }

                            &#tummy {
                                left: 3.8em;
                                bottom: 15.5em;

                                .hitbox {
                                    &__tooltip {
                                        left: calc(100% + 36px);
                                    }
                                }
                            }

                            &#bikini {
                                left: 4em;
                                bottom: 12.4em;

                                .hitbox {
                                    &__tooltip {
                                        left: calc(100% + 30px);
                                    }
                                }
                            }

                            &#thighs {
                                left: 4em;
                                bottom: 9.5em;

                                .hitbox {
                                    &__tooltip {
                                        left: calc(100% + 30px);
                                    }
                                }
                            }

                            &#calves {
                                left: 70px;
                                bottom: 70px;

                                .hitbox {
                                    &__tooltip {
                                        left: calc(100% + 20px);
                                    }
                                }
                            }

                            &#feet {
                                left: 56px;
                                bottom: 14px;

                                .hitbox {
                                    &__tooltip {
                                        left: calc(100% + 40px);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .zoom-out-controller {
                position: absolute;
                left: 1em;
                top: 1em;
            }
        }

        &.zoom-in {
            cursor: pointer;
        }
    }

    .offer-details {
        margin-left: 2em;
        width: 30em;
        background: white;
        border-radius: 1em;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;

        .content-container {
            box-shadow: 0 0 1em #0000001f;
            border-radius: 1em;
            padding: 2.5em 2em;
            width: 100%;

            .header {
                .headline {
                    font-size: 1.85em;
                    font-weight: 700;
                    color: #262626;
                    margin-bottom: .25em;
                    text-align: left;
                }

                .column {
                    font-size: 12px;
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    margin-bottom: 1em;
                    color: #9c9c9c;

                    .offer-duration-container {

                    }
                    .last-month-price-container {
                        display: flex;
                        align-items: center;

                        .info-mark {
                            position: relative;
                            width: 14px;
                            height: 14px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: 1px solid #9c9c9c;
                            border-radius: 14px;
                            margin-right: 4px;
                            font-size: 10px;

                            &:after {
                                position: absolute;
                                content: '';
                                left: -50%;
                                top: -50%;
                                width: 200%;
                                height: 200%;
                                background-color: transparent;;
                            }

                            &:hover {
                                .info-mark__information {
                                    opacity: 1;
                                    transform: translateY(0);
                                }
                            }

                            &__information {
                                position: absolute;
                                bottom: calc(100% + 6px);
                                left: 0;
                                width: 240px;
                                background-color: white;
                                box-shadow: -1px 4px 10px rgba(0, 0, 0, 0.15);
                                padding: 6px;
                                border-radius: 12px 12px 12px 0;
                                color: black;
                                opacity: 0;
                                pointer-events: none;
                                transform: translateY(4px);
                                transition: opacity 200ms ease, transform 200ms ease;
                            }
                        }
                    }

                    span {
                        font-weight: 700;
                        margin-left: 2px;
                    }
                }

                .price-data-container {
                    display: flex;
                    align-items: flex-start;
                    flex-direction: column;
                    width: 100%;

                    .prices-container {
                        display: flex;
                        width: 100%;

                        .pricing-price {
                            font-size: 20px;
                            font-weight: 700;
                            color: #3B3C43;
                        }

                        .pricing-old-price {
                            font-size: 14px;
                            margin-left: .5em;
                            font-weight: 700;
                            color: #646464;
                            text-decoration: line-through;
                            display: flex;
                            align-items: flex-end;
                            padding-bottom: 2px;
                        }
                    }

                    .discount {
                        margin-top: 0;
                        background: #246DD7;
                        display: inline-block;
                        color: white;
                        font-weight: 700;
                        padding: .3em 1em;
                        border-radius: .7em;
                        font-size: 12px;
                    }
                }
            }

            .content {
                padding: 2em 0;
                color: #3B3C43;

                .title {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    .icon {
                        margin-right: .5em;
                    }
                }

                > * {
                    padding-top: .5em;

                    &:first-of-type {
                        padding-top: 0;
                    }
                }
            }

            .footer {
                display: flex;
                flex-direction: column;
                padding: 1em 0;
                gap: 1em;

                .footer-controls-state {
                    display: flex;
                    justify-content: space-between;
                    gap: 1em;

                    .public-layout-product-select {
                        .options-wrapper {
                            padding: 0;
                        }
                    }

                    .public-layout-offer-add-to-cart-button {
                        min-width: 40px;
                    }
                }

                .footer-controls {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .button {
                        text-decoration: underline;

                        @media (pointer: fine) {
                            &:hover {
                                text-decoration: none;
                                font-weight: unset;

                                & > span {
                                    text-decoration: none;
                                    font-weight: unset;
                                }
                            }
                        }
                    }
                }
            }

            > * {
                border-bottom: .01em solid #d5d5d5;
                padding-bottom: 2em;

                &:last-of-type {
                    border-bottom: none;
                    padding-bottom: 0;
                }
            }
        }
    }

    @media all and (max-width: ${variables.tabletL}) {
        .columns-container {
            .hitboxes-container {
                .hitbox {
                    .controls-layer {
                        .hitbox__tooltip {
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        flex-direction: column;

        .hitbox {
            &__tooltip {
                display: none;
            }
        }

        .offer-details {
            margin-top: 2em;
        }
    }

    @media all and (max-width: ${variables.mobileM}) {

        .offer-details {
            margin-left: 0;
        }
    }
`;
